export default __webpack_public_path__ + "static/media/2001.b634a4fc.png";